import {Link} from "react-router-dom";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import Constants from "../../config/constants";
import {Box} from "@mui/material";
import {replaceUrlParams} from "../../config/urls";

const DetailsCliffRouteItem = ({i18n, t, route, cliffRoute, tickingRootUrl, index, open, setOpen}) => {
    const ticking = route.tickings.find((t) => parseInt(t.cliffRouteId) === parseInt(cliffRoute.id));
    const tickingType = Constants.allTickingTypeOptions.find((o) => parseInt(o.value) === parseInt(ticking?.tickingType));
    const tickingLink = ticking?.id ? replaceUrlParams(`${tickingRootUrl}/${cliffRoute.slug}/{ticking}/{crudView}/${ticking.id}`, i18n.language)
        : replaceUrlParams(`${tickingRootUrl}/${cliffRoute.slug}/{ticking}/{crudCreate}`, i18n.language);

    const onOpenClick = () => {
        if (!cliffRoute.description) {
            setOpen(null);
            return;
        }
        setOpen(cliffRoute.id);
    }

    const isOpen = cliffRoute.description && open;

    return <>
        <tr className={index%2 !== 0  ? "odd" : ""}>
            {cliffRoute.summaryLine && <>
                <td colSpan="5" style={{textAlign: 'center'}}>
                    <label className="primary mb-0" dangerouslySetInnerHTML={{__html: cliffRoute.label}}/>
                </td>
            </>}
            {!cliffRoute.summaryLine && <>
                <td>{cliffRoute.number}</td>
                <td onClick={() => onOpenClick()}>
                    <Box display="flex" alignItems="center">
                        <Box>
                            <span dangerouslySetInnerHTML={{__html: cliffRoute.label}}/>
                        </Box>
                        {cliffRoute.description && <Box pl={1}> <FontAwesomeIcon
                            icon={["fas", 'info-circle']}
                            style={{marginLeft: '8px', marginRight: '10px'}}
                            className={"secondary " + (isOpen ? "is-active" : "")}
                        /></Box>}
                        {/*{cliffRoute.type === 'multipitch' &&  <Box pl={1}><RouteAvatar*/}
                        {/*    size="small"*/}
                        {/*    item={cliffRoute} /></Box>}*/}
                    </Box>
                </td>
                <td>{cliffRoute.gradeLabel}</td>
                <td>
                    {cliffRoute.equipedBy}
                </td>
                <td style={{textAlign: 'right'}}>
                    <Link to={tickingLink}>
                        {tickingType && <FontAwesomeIcon icon={tickingType.icon} className={tickingType.color} title={t(tickingType.label)} style={{marginRight: '4px'}} />}
                        {!tickingType && <FontAwesomeIcon icon={["fas", 'plus']} style={{marginRight: '4px'}}  />}
                    </Link>
                </td>
            </>}
        </tr>
        {isOpen && <tr className="highlight" onClick={() => setOpen(null)}>
            <td colSpan="5">
                <span className="wysiwyg" dangerouslySetInnerHTML={{__html: cliffRoute.description}}/>
            </td>
        </tr>}
    </>
}

export default
    compose(
        withTranslation()
    )(DetailsCliffRouteItem);